import { IEntityService } from './me-entity.types'
import { http } from '@/shared/https'

export class EntityService implements IEntityService {

    /** method to get the list of entities */
    getEntities(): any {
        return http.get(`api/MeEntity/`).then((resp: any) => {
            return resp.data;
        });
    }

    getLookUps(field: string): any {
        return http.get(`api/MeIndicatorMapping/GetLookUp/${field}`).then((resp: any) => {
            if(resp.data.Result === 'OK') {
                return resp.data.Record.reduce((out, obj) => {
                    out[obj["Value"]] = obj["DisplayText"];
                    return out;
                },{});
            } else {
                return {};
            }
        }).catch((e) => {
            return {};
        })
    }

    /** method to create new entity */
    createEntity(entity: any) {
        return http.post('api/MeEntity', entity).then((resp: any) => {
            if (resp.data.Result === 'OK') {
                return resp.data.Record;
            } else {
                throw(resp.data.Message);
            }
        })
    }

    /** method to update the entity */
    updateEntity(id: number, entity: any){
        return http.put(`api/MeEntity/`, entity).then((resp: any) => {
            if (resp.data.Result === 'OK') {
                return resp.data.Record;
            } else {
                return {};
            }
        })
    }

    /** method to delete the entity */
    deleteEntity(id: number){
        return http.delete(`api/MeEntity/${id}`);
    }

    /** method to get the list of indicators */
    getIndicators(): any {
        return http.get(`api/MeIndicatorMapping/Indicators`).then((resp: any) => {
            return resp.data;
        });
    }

    getIndicatorMapping(): any {
        return http.get(`api/MeIndicatorMapping`).then((resp: any) => {
            return resp.data;
        });
    }


    /** method to create new mapping */
    createMapping(mapping: any) {
        return http.post('api/MeIndicatorMapping', mapping).then((resp: any) => {
            if (resp.data.Result === 'OK') {
                return resp.data.Record;
            } else {
                throw(resp.data.Message);
            }
        })
    }

    /** method to delete the mapping */
    deleteMapping(id: number){
        return http.delete(`api/MeIndicatorMapping/${id}`);
    }

} 